"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _CornerstoneForm = _interopRequireDefault(require("cornerstone_ui_core/lib/components/CornerstoneForm"));
var _CornerstoneRow = _interopRequireDefault(require("cornerstone_ui_core/lib/components/CornerstoneRow"));
var _CornerstoneCard = _interopRequireDefault(require("cornerstone_ui_core/lib/components/CornerstoneCard"));
var _CornerstoneButton = _interopRequireDefault(require("cornerstone_ui_core/lib/components/CornerstoneButton"));
var _CornerstoneModal = _interopRequireDefault(require("cornerstone_ui_core/lib/components/CornerstoneModal"));
var _DraggableTitle = _interopRequireDefault(require("../DraggableTitle/DraggableTitle"));
var _CornerstoneCol = _interopRequireDefault(require("cornerstone_ui_core/lib/components/CornerstoneCol"));
var _CornerstoneSwitch = _interopRequireDefault(require("cornerstone_ui_core/lib/components/CornerstoneSwitch"));
var _reactColor = require("react-color");
require("./accessibility.scss");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
class Accessibilty extends _react.Component {
  constructor(props) {
    var _this$props$adaSettin, _this$props$adaSettin2, _this$props$adaSettin3, _this$props$adaSettin4, _this$props$adaSettin5;
    super(props);
    _defineProperty(this, "handleChangeComplete", (color, event) => {
      let restrictedColors = ["#000000", "#36454f", "#023020", "#301934", "#343434", "#1b1212", "#28282b", "#353935", "#191970", "#0c0404", "#413839", "#3b3c36", "#232b2b", "#1a2421", "#1b1b1b", "#504a4b", "#2c3539", "#3d3c3a", "#1a1110", "#2b1b17", "#0c090a", "#242124", "#100c08", "#040200", "#080806", "#050301", "#0b0705", "#000302", "#020403", "#010203", "#07000b", "#050203", "#060403", "#060605", "#010207", "#080706", "#080808", "#050505"];
      if (restrictedColors.includes(color.hex)) {
        this.setState({
          displayColorPicker: false,
          darkColorErr: true
        });
      } else {
        const hexColorCode = "".concat(color.hex).concat(Math.round(color.rgb.a * 255).toString(16));
        this.setState({
          color: hexColorCode
        });
      }
    });
    _defineProperty(this, "handleClick", () => {
      this.setState({
        displayColorPicker: !this.state.displayColorPicker,
        darkColorErr: false
      });
    });
    _defineProperty(this, "handleClose", () => {
      this.setState({
        displayColorPicker: false
      });
    });
    _defineProperty(this, "onCloseModal", () => {
      this.props.onCancel();
    });
    _defineProperty(this, "accessibiltyClassUpdate", adaData => {
      //filter name - bold font,
      // filter value - large Font
      //sortIndicator - dark cell
      let adaColor = "#e0e5ff";
      if (adaData.visibleIndicator.at(9) === "Y") {
        adaColor = adaData.visibleIndicator.substring(0, 9);
      }
      const root = document.documentElement;
      root.style.setProperty("--ada-color", adaColor);
      let bodyTag = document.getElementsByTagName("body")[0];
      if (adaData.filterName === "Y") bodyTag.classList.add("ada-bold-font");else bodyTag.classList.remove("ada-bold-font");
      if (adaData.visibleIndicator.at(9) === "Y") bodyTag.classList.add("ada-shaded-card");else bodyTag.classList.remove("ada-shaded-card");
      if (adaData.filterValue === "Y") bodyTag.classList.add("ada-large-font");else bodyTag.classList.remove("ada-large-font");
      if (adaData.sortIndicator === "Y") bodyTag.classList.add("ada-dark-cell");else bodyTag.classList.remove("ada-dark-cell");
      let adaSetting = {
        adaBold: adaData.filterName === "Y" ? true : false,
        //adabold - filter Name
        adaLargeFont: adaData.filterValue === "Y" ? true : false,
        //adaLarge - filterValue
        adaShadeColor: adaData.visibleIndicator.substring(0, 9),
        //adaColor
        adaShade: adaData.visibleIndicator.at(9) === "Y" ? true : false,
        // adaShade
        adaDarkCell: adaData.sortIndicator === "Y" ? true : false //adaDark cell - SortIndicator
      };

      this.props.updateProp(adaSetting);
    });
    _defineProperty(this, "saveAccessibility", () => {
      //api call
      const userADASettingColumnList = [{
        columnAttribute: "ADA_SETTING",
        columnHeader: "ADA_SETTING",
        columnName: "ADA_SETTING",
        visibleIndicator: this.state.shadedOnState ? "".concat(this.state.color, "Y") : "".concat(this.state.color, "N"),
        filterName: this.state.boldOnState ? "Y" : "N",
        filterValue: this.state.largeFontOnState ? "Y" : "N",
        sortIndicator: this.state.darkCellOnState ? "Y" : "N"
      }];
      this.props.applyUserGridSettings("ADA_SETTING", userADASettingColumnList);
      this.props.onCancel();
      this.accessibiltyClassUpdate(userADASettingColumnList[0]);
    });
    _defineProperty(this, "saveMasterAccessibility", () => {
      this.props.saveInMaster(this.state.boldOnState, this.state.shadedOnState, this.state.color, this.state.largeFontOnState, this.state.darkCellOnState);
      this.props.onCancel();
    });
    this.state = {
      boldOnState: this.props.isMaster ? localStorage.getItem("adaBold") === "true" ? true : false : (_this$props$adaSettin = this.props.adaSetting) === null || _this$props$adaSettin === void 0 ? void 0 : _this$props$adaSettin.adaBold,
      shadedOnState: this.props.isMaster ? localStorage.getItem("adaShaded") === "true" ? true : false : this.props.adaSetting && this.props.adaSetting.adaShade ? true : false,
      displayColorPicker: false,
      color: this.props.isMaster ? localStorage.getItem("adaShadedColor") ? localStorage.getItem("adaShadedColor") : "#e0e5ffff" : (_this$props$adaSettin2 = this.props.adaSetting) !== null && _this$props$adaSettin2 !== void 0 && _this$props$adaSettin2.adaShadeColor ? (_this$props$adaSettin3 = this.props.adaSetting) === null || _this$props$adaSettin3 === void 0 ? void 0 : _this$props$adaSettin3.adaShadeColor : "#e0e5ffff",
      largeFontOnState: this.props.isMaster ? localStorage.getItem("adaLargeFont") === "true" ? true : false : (_this$props$adaSettin4 = this.props.adaSetting) === null || _this$props$adaSettin4 === void 0 ? void 0 : _this$props$adaSettin4.adaLargeFont,
      darkCellOnState: this.props.isMaster ? localStorage.getItem("adaDarkCell") === "true" ? true : false : (_this$props$adaSettin5 = this.props.adaSetting) === null || _this$props$adaSettin5 === void 0 ? void 0 : _this$props$adaSettin5.adaDarkCell
    };
  }
  render() {
    const styles = {
      color: {
        width: "36px",
        height: "14px",
        borderRadius: "2px",
        background: this.state.color
      },
      swatch: {
        padding: "5px",
        background: "#fff",
        borderRadius: "1px",
        boxShadow: "0 0 0 1px rgba(0,0,0,.1)",
        display: "inline-block",
        cursor: "pointer"
      },
      popover: {
        position: "absolute",
        zIndex: "2"
      },
      cover: {
        position: "fixed",
        top: "0px",
        right: "0px",
        bottom: "0px",
        left: "0px"
      }
    };
    return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_CornerstoneModal.default, {
      title: /*#__PURE__*/_react.default.createElement(_DraggableTitle.default, {
        title: "Accessibilty"
      }),
      width: "40%",
      visible: this.props.openAccessibility,
      onCancel: this.onCloseModal,
      className: "accessibility-modal",
      footer: [/*#__PURE__*/_react.default.createElement(_CornerstoneButton.default, {
        key: "cancel",
        onClick: this.onCloseModal
      }, "Cancel"), /*#__PURE__*/_react.default.createElement(_CornerstoneButton.default, {
        key: "submit",
        type: "primary",
        onClick: this.props.isMaster ? this.saveMasterAccessibility : this.saveAccessibility
      }, "Save")],
      maskClosable: false
    }, /*#__PURE__*/_react.default.createElement(_CornerstoneForm.default, null, /*#__PURE__*/_react.default.createElement(_CornerstoneRow.default, {
      className: "mt-2"
    }, /*#__PURE__*/_react.default.createElement(_CornerstoneForm.default.Item, {
      style: {
        fontWeight: "bold"
      },
      label: "System"
    })), /*#__PURE__*/_react.default.createElement(_CornerstoneRow.default, {
      className: "mt-3"
    }, /*#__PURE__*/_react.default.createElement(_CornerstoneCol.default, {
      span: 12
    }, "Bold Font"), /*#__PURE__*/_react.default.createElement(_CornerstoneCol.default, {
      span: 12
    }, /*#__PURE__*/_react.default.createElement(_CornerstoneSwitch.default, {
      onChange: checked => {
        this.setState({
          boldOnState: checked
        });
      },
      checked: this.state.boldOnState
    }))), /*#__PURE__*/_react.default.createElement(_CornerstoneRow.default, {
      className: "mt-3"
    }, /*#__PURE__*/_react.default.createElement(_CornerstoneCol.default, {
      span: 12
    }, "Larger Font "), /*#__PURE__*/_react.default.createElement(_CornerstoneCol.default, {
      span: 12
    }, /*#__PURE__*/_react.default.createElement(_CornerstoneSwitch.default, {
      onChange: checked => {
        this.setState({
          largeFontOnState: checked
        });
      },
      checked: this.state.largeFontOnState
    }))), /*#__PURE__*/_react.default.createElement(_CornerstoneRow.default, {
      className: "mt-3"
    }, /*#__PURE__*/_react.default.createElement(_CornerstoneCol.default, {
      span: 12
    }, "Shaded Cards"), /*#__PURE__*/_react.default.createElement(_CornerstoneCol.default, {
      span: 12
    }, /*#__PURE__*/_react.default.createElement(_CornerstoneSwitch.default, {
      onChange: checked => {
        this.setState({
          shadedOnState: checked
        });
      },
      checked: this.state.shadedOnState
      // checked={localStorage.getItem("adaShaded")?localStorage.getItem("adaShaded"):this.state.shadedOnState}
    }))), this.state.shadedOnState ? /*#__PURE__*/_react.default.createElement(_CornerstoneRow.default, {
      className: "mt-3"
    }, /*#__PURE__*/_react.default.createElement(_CornerstoneCol.default, {
      span: 12
    }, "Shaded Cards Color"), /*#__PURE__*/_react.default.createElement(_CornerstoneCol.default, {
      span: 12
    }, /*#__PURE__*/_react.default.createElement("div", {
      style: styles.swatch,
      onClick: this.handleClick
    }, /*#__PURE__*/_react.default.createElement("div", {
      style: styles.color
    })), this.state.displayColorPicker ? /*#__PURE__*/_react.default.createElement("div", {
      style: styles.popover
    }, /*#__PURE__*/_react.default.createElement("div", {
      style: styles.cover,
      onClick: this.handleClose
    }), /*#__PURE__*/_react.default.createElement(_reactColor.SketchPicker, {
      color: this.state.color,
      onChangeComplete: this.handleChangeComplete
    })) : this.state.darkColorErr ? /*#__PURE__*/_react.default.createElement("div", {
      style: {
        color: "red"
      }
    }, "Please select a lighter shade") : null)) : "", /*#__PURE__*/_react.default.createElement(_CornerstoneRow.default, {
      className: "mt-3"
    }, /*#__PURE__*/_react.default.createElement(_CornerstoneCol.default, {
      span: 12
    }, "Darken Field & Cell Lines"), /*#__PURE__*/_react.default.createElement(_CornerstoneCol.default, {
      span: 12
    }, /*#__PURE__*/_react.default.createElement(_CornerstoneSwitch.default, {
      onChange: checked => {
        this.setState({
          darkCellOnState: checked
        });
      },
      checked: this.state.darkCellOnState
    }))))));
  }
}
var _default = exports.default = _CornerstoneForm.default.create({
  name: "Accessibilty"
})(Accessibilty);